import { ROUTE_IDS } from '../../experience/routes/ids.js';
import { COMMON_AVATAR_ROUTE_IDS, ORG_USER_CLIENT_BASELINE_MODULES, } from './presets.js';
export const ORGANIZATION_USER_ACCESS_PROFILE = {
    persona: 'ORG_USER',
    actorTypes: ['USER'],
    scope: {
        allowedKinds: ['ORGANIZATION', 'BRANCH', 'CLIENT', 'PORTFOLIO'],
        defaultKind: 'ORGANIZATION',
        organizationRequired: true,
        branchRequired: false,
        clientRequired: false,
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
    },
    authentication: {
        defaultAal: 'AAL1',
        administrationAal: 'AAL2',
    },
    navigation: {
        landingRouteId: ROUTE_IDS.DASHBOARD,
        primaryRouteIds: [ROUTE_IDS.DASHBOARD, ROUTE_IDS.DATA_HUB, ROUTE_IDS.REPORTS],
        avatarRouteIds: COMMON_AVATAR_ROUTE_IDS,
        structurallyDeniedRouteIds: [
            ROUTE_IDS.ADMIN_HUB,
            ROUTE_IDS.PLATFORM_ADMIN_HUB,
            ROUTE_IDS.ORGANIZATION_ADMIN_HUB,
            ROUTE_IDS.ORGANIZATION_GOVERNANCE_WORKSPACE,
            ROUTE_IDS.ORGANIZATION_USERS_LIST,
            ROUTE_IDS.ORGANIZATION_ROLES_LIST,
            ROUTE_IDS.ORGANIZATION_PROFILE,
            ROUTE_IDS.ORGANIZATION_AUDIT_LIST,
            ROUTE_IDS.ORGANIZATION_ACCESS_INSPECTOR,
            ROUTE_IDS.PLATFORM_ACCESS_INSPECTOR,
            ROUTE_IDS.PLATFORM_ORGANIZATIONS_LIST,
            ROUTE_IDS.PLATFORM_USERS_LIST,
            ROUTE_IDS.PLATFORM_MODULES_LIST,
            ROUTE_IDS.PLATFORM_AUDIT_LIST,
            ROUTE_IDS.SETTINGS_MFA,
        ],
    },
    access: {
        defaultOperationBundleIds: ['organization-user-base', 'organization-report-reader'],
        allowedOperationBundleIds: [
            'organization-user-base',
            'organization-data-reader',
            'organization-transaction-operator',
            'organization-report-reader',
        ],
    },
    modules: {
        baseline: ORG_USER_CLIENT_BASELINE_MODULES,
        optional: ['RECONCILIATION', 'CORPORATE_ACTIONS', 'HOLDINGS', 'DATA'],
        forbidden: ['PLATFORM', 'ADMIN', 'ACCOUNTING', 'TAX', 'IMPORT', 'INSTRUMENTS', 'FACTS', 'MARGIN_TRADING', 'ORDER_MANAGEMENT'],
    },
    administration: { resourceIds: [] },
    context: {
        maySwitchOrganization: false,
        maySwitchBranch: false,
        maySelectClient: false,
        maySelectPortfolio: false,
    },
    delegation: {
        mayInitiate: false,
        mayReceive: false,
        organizationDataRequiresDelegation: false,
    },
    mutationPolicy: 'ASSIGNED_OPERATIONS',
};
